import React from 'react';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from './MyAppText';
import FormActions from './FormActions';
import CustomButton, { ButtonTypes } from './CustomButton';
import { ScrollView } from 'react-native-web-hover';
import { translate } from '../services/translate';

interface Props {
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    onSubmit: () => void;
    onClose: () => void;
    text: React.ReactNode;
    items?: string[];
    confirmType?: ButtonTypes;
    confirmText?: string;
    cancelText?: string;
    singleButton?: boolean;
}

/**
 * @deprecated
 * use AlertModal instead
 */
function WarningModal({ isModalVisible, setIsModalVisible, onSubmit, onClose, text, items, confirmType, confirmText, cancelText, singleButton }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    return (
        <Modal transparent={true} visible={isModalVisible} animationType='fade' onRequestClose={() => setIsModalVisible(false)}>
            <View style={styles.container}>
                <View style={styles.formContainer}>
                    <MyAppText>{text}</MyAppText>
                    {items && items?.length > 0 && <ScrollView style={{ flex: 1, maxHeight: 80 }}>
                        {items.map((item, index) => (
                            <View key={`${item}_${index}`} style={{ flexDirection: 'row', gap: 4, alignItems: 'baseline' }}>
                                <View style={{ width: 8, height: 8, borderRadius: 9999, backgroundColor: theme.colors.neutral['400'] }} />
                                <MyAppText>{item}</MyAppText>
                            </View>
                        ))}
                    </ScrollView>}
                    {singleButton
                        ? <View style={{ flexDirection: 'row' }}>
                            <CustomButton
                                style={{ paddingHorizontal: 16, paddingVertical: 9, flex: 1 }}
                                contentContainerStyle={{ flex: 1 }}
                                onPress={() => onClose()}
                                text={translate(cancelText ?? 'cancel')}
                            />
                        </View>
                        : <FormActions
                            viewStyle={{ flex: 1, justifyContent: 'space-around' }}
                            buttonStyle={{ paddingHorizontal: 16, paddingVertical: 9, }}
                            buttonContentContainerStyle={{ flex: 1 }}
                            onSubmit={async () => onSubmit()}
                            onClose={() => onClose()}
                            disabled={false}
                            cancelText={cancelText}
                            confirmText={confirmText ?? 'continue'}
                            confirmType={confirmType} />}
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    formContainer: {
        width: 350,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32,
    },
}));


export default WarningModal;
